import script from "./EsportSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportSlider.vue?vue&type=script&setup=true&lang=js"

import "./EsportSlider.vue?vue&type=style&index=0&id=6853141c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6853141c"]])

export default __exports__